import { ReportShell } from "@/components/reports/ReportShell";

// Route-level RBAC: `/rapporter` is gated by canAccess("rapporter") in App.tsx,
// so this page only renders for authorized roles. The framework shell handles
// metric selection, period, drilldown and export.
//
// NB: the legacy commission report (useCommissionReport, CommissionReportSummary,
// ReportPeriodPicker, CommissionReportExport) is intentionally NOT deleted — it
// will be reused by the `provisjon` resolver in a later task.
export default function ReportsPage() {
  return <ReportShell />;
}
